module.exports = __webpack_public_path__ + "static/media/icon_ios.8ee76e47.png";